import { useState } from 'react';
import highlightedWorksData from '../data/highlights.json';
import workData from '../data/works.json';

import '../global.css';
import ParticlesBackground from "../components/ParticlesBackground";
import HighlightedWorks from '../components/HighlightedWorks';
import MonetModal from '../components/MonetModal';
import GetTraindModal from '../components/GetTraindModal';
import Navigation from '../components/Navigation';
import FooterCentered from '../components/FooterCentered';
import { motion } from "framer-motion";

const highlightedWorks = highlightedWorksData.map((highlightedWork) => ({
    ...highlightedWork,
    images: highlightedWork.images.map((img) => require(`../media/${img}`))
}));

const works = workData.map((work) => ({
    ...work,
    imageSrc: require(`../media/${work.imageSrc}`),
}));

export default function Works() {
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState("");
    const [selectedWork, setSelectedWork] = useState(null);

    const handleEmail = (e) => {
        e.preventDefault();
        console.log(email);
    }

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="bg-void min-h-screen"
        >
            <ParticlesBackground id="tsparticles" />
            <Navigation />

            <HighlightedWorks works={highlightedWorks} />

            <div className="max-w-4xl mx-auto px-6 lg:px-8 pt-8">
                <p className="text-xs font-outfit font-semibold tracking-[0.2em] uppercase text-accent mb-2">
                    More Projects
                </p>
                <h2 className="font-syne text-2xl font-bold text-text-primary">
                    Additional work
                </h2>
            </div>

            <div className="mx-auto max-w-4xl px-6">
                <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                    {works.map((work) => (
                        <div
                            key={work.id}
                            className="group relative flex flex-col overflow-hidden rounded-xl border border-border-subtle bg-surface/50 transition-all duration-300 hover:border-accent/20 hover:-translate-y-1 cursor-pointer"
                            onClick={() => {
                                setSelectedWork(work);
                                setOpen(true);
                            }}
                        >
                            <div className="aspect-square group-hover:opacity-80 transition-opacity duration-300">
                                <a href={work.href} target="_blank" rel="noopener noreferrer">
                                    <img
                                        src={work.imageSrc}
                                        alt={work.name}
                                        className="h-full w-full object-cover"
                                    />
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <MonetModal
                open={selectedWork?.name === 'Monet.ai'}
                setOpen={setSelectedWork}
                email={email}
                setEmail={setEmail}
                handleEmail={handleEmail}
            />
            <GetTraindModal
                open={open && selectedWork && selectedWork.name === 'GetTraind'}
                setOpen={setOpen}
                selectedWork={selectedWork}
            />

            <div className="mt-20" />
            <FooterCentered />
        </motion.div>
    );
}
